define([], function () {
    var framework = {

    };

    function i18n(key) {
        return i18n.framework[key];
    };
    i18n.framework = framework;
    return i18n;
})


// WEBPACK FOOTER //
// ./public/hws/i18n/th-th/resourcehk.js